function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AnimatePresence, motion } from 'framer-motion';
import { FullBox, FullColumn } from 'seagull';
import { COBStep } from "../../ClientOnboarding.utils";
import { PreviewBanner } from "../../PreviewBanner";
import { getVendorGradientStyle } from "../ClientOnboardingV2.utils";
import { CoverPage } from "../CoverPage/CoverPage";
import { Footer } from "../OnboardingPage/Footer/Footer";
import { MobileHeader } from "../OnboardingPage/MobileHeader/MobileHeader";
import { OnboardingPage } from "../OnboardingPage/OnboardingPage";
import { animatePresenceVariants, mobileFooterVariants, mobileHeaderVariants, pageTransition, pageVariants } from "./animations.mobile";
import styles from "./ClientOnboardingContentMobile.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ClientOnboardingContentMobile = _ref => {
  let {
    relationship,
    currentStep,
    previewState,
    dismissPreviewModal,
    setCurrentStep,
    visitedSteps,
    directionRef,
    hasVisitedCoverPageRef,
    handleBack,
    handleNext,
    statement,
    isStatementAccepted,
    onStatementChange,
    isNextDisabled,
    hideNextButton
  } = _ref;
  const isPreview = !!previewState;
  const isCoverPage = currentStep === COBStep.welcome;
  const handleGetStarted = () => {
    hasVisitedCoverPageRef.current = true;
    setCurrentStep(COBStep.introduction);
  };
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  const contentAreaClassName = "".concat(styles.contentArea, " ").concat(isCoverPage ? styles.contentAreaCover : hideNextButton ? styles.contentAreaNoFooter : styles.contentAreaOnboarding);
  const coverPageContent = /*#__PURE__*/_jsx(CoverPage, {
    relationship: relationship,
    onGetStarted: handleGetStarted,
    isPreview: isPreview,
    showRecipientToast: !hasVisitedCoverPageRef.current && !previewState
  });
  const onboardingPageContent = /*#__PURE__*/_jsx(OnboardingPage, {
    relationship: relationship,
    currentStep: currentStep,
    direction: directionRef.current,
    onStepClick: setCurrentStep,
    onBack: handleBack,
    onNext: handleNext,
    visitedSteps: visitedSteps,
    statement: statement,
    isStatementAccepted: isStatementAccepted,
    onStatementChange: onStatementChange,
    isNextDisabled: isNextDisabled
  });
  return /*#__PURE__*/_jsxs(FullColumn, {
    className: styles.container,
    children: [isPreview && /*#__PURE__*/_jsx(PreviewBanner, {
      previewState: previewState,
      onDismiss: dismissPreviewModal
    }), /*#__PURE__*/_jsxs(FullBox, {
      flexDirection: "column",
      className: styles.contentBox,
      style: gradientStyle,
      children: [/*#__PURE__*/_jsx(AnimatePresence, {
        children: !isCoverPage && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({
          className: styles.headerWrapper,
          variants: mobileHeaderVariants
        }, animatePresenceVariants), {}, {
          children: /*#__PURE__*/_jsx(MobileHeader, {
            relationship: relationship,
            showBack: true,
            onBack: handleBack
          })
        }), "mobile-header")
      }), /*#__PURE__*/_jsx(AnimatePresence, {
        mode: "wait",
        initial: false,
        custom: isCoverPage,
        children: /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({
          custom: isCoverPage,
          variants: pageVariants,
          transition: pageTransition
        }, animatePresenceVariants), {}, {
          className: contentAreaClassName,
          children: isCoverPage ? coverPageContent : onboardingPageContent
        }), isCoverPage ? 'cover' : 'inner')
      }), /*#__PURE__*/_jsx(AnimatePresence, {
        children: !isCoverPage && !hideNextButton && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({
          className: styles.footerWrapper,
          variants: mobileFooterVariants
        }, animatePresenceVariants), {}, {
          children: /*#__PURE__*/_jsx(Footer, {
            currentStep: currentStep,
            relationship: relationship,
            onNext: handleNext,
            isNextDisabled: isNextDisabled
          })
        }), "mobile-footer")
      })]
    })]
  });
};